import { render, staticRenderFns } from "./data-sources-disclaimer.vue?vue&type=template&id=1369db51&scoped=true"
import script from "./data-sources-disclaimer.vue?vue&type=script&lang=js"
export * from "./data-sources-disclaimer.vue?vue&type=script&lang=js"
import style0 from "./data-sources-disclaimer.vue?vue&type=style&index=0&id=1369db51&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1369db51",
  null
  
)

export default component.exports